import UiSphereO3 from "../object3d/UiSphere";
import { v3 } from "oc-threejs/short3";
import Maths3 from "oc-threejs/Maths3";
import Schrank from "../arrangement/Schrank";
import { Scene } from "three";
import Scenes from "oc-threejs/Scenes";

export default class UiSphere {
    // DO NOT CHANGE
    className = "UiSphere";

    constructor(schrank, direction) {
        this.schrank = schrank;
        this.direction = direction;
        this.offset = 50;
        this.diameter = 15;
        this.initCoordinateSystem();
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    initCoordinateSystem() {
        this._matrix = new THREE.Matrix4();
        this._inverseMatrix = new THREE.Matrix4();
        const setMatrixNeedsUpdate = () => {
            this._matrixNeedsUpdate = true;
        };
        this.position = THREE.Vector3.initWithObservation(setMatrixNeedsUpdate);
        this.quaternion = new THREE.Quaternion().onChange(setMatrixNeedsUpdate);
    }

    _maybeUpdateMatrix() {
        if (this._matrixNeedsUpdate) {
            this._matrix.compose(this.position, this.quaternion, Maths3.vector.one);
            this._inverseMatrix.getInverse(this._matrix);
            this._matrixNeedsUpdate = false;
        }
    }

    get matrix(): THREE.Matrix4 {
        this._maybeUpdateMatrix();
        return this._matrix;
    }

    get inverseMatrix(): THREE.Matrix4 {
        this._maybeUpdateMatrix();
        return this._matrix;
    }

    toBoxPosition(key) {
        switch (key) {
            case "left":
                return v3(0, 0.5, 0.5);
            case "right":
                return v3(1, 0.5, 0.5);
            case "top":
                return v3(0.5, 1, 0.5);
            case "bottom":
                return v3(0.5, 0, 0.5);
        }
    }

    compile() {
        this.size = v3().fromJSON({ x: this.diameter, y: this.diameter, z: this.diameter });
        this.box = new THREE.Box3(v3(0, 0, 0), this.size.clone());

        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new UiSphereO3(this);
            this.schrank.child3dContainer.add(o3);
            return o3;
        });
    }

    onTap() {
        const sidebarBefore = APP.uiHandler.ui.state.sidebar.type;
        APP.uiHandler.ui.hideSidebar();
        APP.uiHandler.ui.showSidebar("neuerSchrank", {direction: this.direction, schrank: this.schrank, sidebarBefore: sidebarBefore});
    }
}
